import { render, staticRenderFns } from "./AddShoppingNumDialog.vue?vue&type=template&id=4d95d56e&scoped=true"
import script from "./AddShoppingNumDialog.vue?vue&type=script&lang=js"
export * from "./AddShoppingNumDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d95d56e",
  null
  
)

export default component.exports